import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function removeSlide({ slideId }) {
  const response = await axiosInstance.delete(
    `${API_URL}/slides/delete/${slideId}`,
    {}
  );
  return response;
}